import React from 'react';
import { IconSvgProps } from '@models/common';

const EditorLoader: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill='none'>
      <path
        fill='#5C47FA'
        fillRule='evenodd'
        d='M4.007 11.66a8 8 0 1 0 8.88-7.61 1.201 1.201 0 0 1-.198-.04c-.457-.13-.808-.525-.815-1.01-.007-.551.435-1.01.985-.963a9.996 9.996 0 0 1 8.502 6.445 10 10 0 1 1-19.333 2.773c.04-.55.565-.914 1.109-.818.477.084.81.494.866.966a1.203 1.203 0 0 1 .007.2m-.003.058.003-.057Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default EditorLoader;
